export const VALID_AUTH_REGIONS = {
  US: 'us',
  EU: 'eu',
};
